<script setup>
import { useRouter } from 'vue-router'
import { onMounted, ref, nextTick } from 'vue'
import { getUserDetailmatch,getOpponent } from '@/services/service'
const router = useRouter()

const route = useRouter().currentRoute.value;
const user_id = ref(null);
user_id.value = route.query.id;


import BScroll from '@better-scroll/core';
const detailsScrollBox = ref(null)
const seepInput = ref(null)
const searchResult = ref(null)
var issearh = ref(false)
const userDetailMessage = ref(null);
// const goToFrontPage = () => {
//   router.push('/')
// }
const goToFrontPage = () => {
    router.push({
        path: '/',
        replace: false
    })
}


const seep = async () => {
    issearh.value = true;
  const result1 = await getOpponent(user_id.value,seepInput.value)
  if(result1!= -1){
    searchResult.value = result1;
  }else{
    issearh.value = false;
  }
}

const goToDetailsPage = (id,match_id,type) => {

    router.push({
        path: '/details',
        query: {
            id: id,
            match_id: match_id,
            rank_id:user_id.value,
            type,
        },
        replace: false
    })
}

const goToOpponentPage = (id,key) => {
    router.push({
        path: '/opponent',
        query: {
            key: key,
            rank_id:user_id.value,
            user_name:userDetailMessage.value.user_message.user_name
        },
        replace: false
    })
}

const goecharts = (id) => {
    router.push({
        path: '/echartpage',
        query: {
          id,
        },
        replace: false
    })
}


onMounted(async () => {
  try {
    userDetailMessage.value = await getUserDetailmatch(user_id.value)
    nextTick(() => {
      new BScroll(detailsScrollBox.value, {
        useTransition: true,
        click: true,
        mouseWheel: true,
      })
    })

  } catch (error) {
    console.error('获取用户详情失败:', error)
  }
})


</script>

<template>
  <div class="details-page" v-if="userDetailMessage">

    <div @click="goToFrontPage" class="left-box">
      <img src="./img/fhsyj.png" alt="" style="width: .5625rem;height: 1rem;">
    </div>

    <div class="header-box rank-default" >
      <div class="header-position-box">
        <div class="header-name">
          {{ userDetailMessage.user_message.user_name }}
        </div>
        <div class="header-points">
          {{ userDetailMessage.user_message.points }}
        </div>
      </div>
      <div  class="header-points2">
          <div class="diqu" >
            地区：   {{ userDetailMessage.user_message.address }}
          </div>
          <div class="diqu" >
            性别： {{ userDetailMessage.user_message.sex==1?"男":"女" }}
          </div>
          <div class="diqu " style="position:relative;top:1rem;height:2rem"  @click="goecharts(userDetailMessage.user_message.rid)" >
            <img src="./img/jfzs.png" alt="">     
          </div>
        </div>
    </div>
    <div class="seep_box">
        <div class="seep_box_img">
            <img src="./img/seek.png" alt="" style="width: 100%; height: 100%;">
        </div>
        <div class="seep_box_input">
            <input type="text" placeholder="请输入对战选手姓名" v-model="seepInput">
        </div>
        <div style="color: #999999;">|</div>
        <div class="seep_box_btn" @click="seep">搜索</div>
    </div>
    <div class="content-title-box2">
      <div class="border-box"></div>
      <div class="title-box">{{issearh==false?'赛事记录':'对手列表'}}</div>
    </div>
    <div class="content_box_content">
            <div class="content_box_content_list" ref="detailsScrollBox">
                <div class="list-item-box" v-show="!issearh">
                    <div class="list_item" v-for="(item, index) in userDetailMessage.points_flow_message" :key="item.id"
                        :class="{ 'classBackground': index % 2 != 0 }">
                        <div style="width: 5%;color: #333333;">{{index+1}}</div>
                        <div style="width: 80%;color: #333333;"  class="hid">{{ item.event_name }}</div>
                        <div style="width: 15%;" @click="goToDetailsPage(item.ranking_id,item.match_id,item.operate_type)">
                            <button>
                                <img src="./img/right.png" alt="" style="width: 0.3125rem; height: .5rem;">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="list-item-box"  v-show="issearh">
                    <div class="list_item" v-for="(item, index) in searchResult" :key="item.id"
                        :class="{ 'classBackground': index % 2 != 0 }">
                        <div style="width: 5%;color: #333333;">{{index+1}}</div>
                        <div style="width: 60%;color: #333333;" >{{ item.opponent }}</div>
                        <div style="width: 20%;color: #333333;text-align:left" >{{ item.win_count }}/{{ item.total_matches}}</div>
                        <div style="width: 15%;" @click="goToOpponentPage(user_id.value,item.opponent)">
                            <button>
                                <img src="./img/right.png" alt="" style="width: 0.3125rem; height: .5rem;">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>


<style scoped lang="less">
.details-page {
  width: 100vw;
  height: 100vh;
  background-color: #F5F5F5;
  font-size: 16px;
  position: absolute;
  padding: 0 .75rem .75rem .75rem;
  overflow: hidden;
  .seep_box {
            width: 95%;
            height: 3rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0.7rem auto;
            padding: 0 1rem;
            background-color: #ffffff;
            border-radius: 0.3125rem;

            .seep_box_img {
                width: 0.875rem;
                height: 0.875rem;
            }

            .seep_box_input {
                width: 13rem;
                height: 1.1563rem;
                line-height: 1.1563rem;

                input {
                    width: 100%;
                    height: 100%;
                    font-size: 1rem;
                    border: none;
                    outline: none;
                    background-color: #F6F7F6;

                }

            }

            .seep_box_btn {
                width: 3.5rem;
                height: 1.3438rem;
                font-size: 1rem;
                color: #3378EB;
                text-align: center;
            }
        }
  .left-box {
    width: 100%;
    height: 2.5rem;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
  }
  .lunci{
    text-align:left;
    font-size:16px;
    width:60px;
  }
  .content_box_content {
            width: 100%;
            margin: 0 auto;
            border-radius: 0.3125rem;
            margin-top: 1.25rem;

            .content_box_title {
                width: 100%;
                height: 2.5rem;
                font-weight: 700;
                margin: 0 auto;
                text-align: center;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .content_box_content_list {
                width: 100%;
                height: calc(100vh - 21rem);
                // height: 33.4375rem;
                overflow: hidden;
                .list-item-box {
                    .classBackground{
                        background-color: #f9f9f9;
                    }
                    width: 100%;
                }


                .list_item {
                    width: 100%;
                    height: 3.125rem;
                    margin: 0 auto;
                    text-align: center;
                    display: flex;
                    background-color: #FFFFFF;
                    justify-content: space-between;
                    align-items: center;
                    border-radius:10px;
                    .ranking-img-box {
                        width: 25%;
                        height: 1.625rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .hid{
                  display: -webkit-box;
                  -webkit-line-clamp: 2; /* 限制显示的行数 */
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
            }
        }
  .rank-default {
    background-image: url('./img/sythbj.png');
  }
  .header-points2{
      width: 100%;
      height: 4rem;
      color: #fff;
      font-size: 1rem;
      position:absolute;
      display: flex;
      justify-content: space-around;
      bottom:0;
      .diqu{
        display: flex;
        justify-content: space-around;
        width:6rem;
        line-height:4rem;
        margin-left:1rem
      }
  }
 
  .header-box {
    width: 100%;
    height: 11rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    border-radius: .3125rem;

    .header-position-box {
      position: absolute;
      top: 1rem;
      left: 1.5rem;

      .header-name {
        font-size: 1rem;
        color: #fff;
        font-weight: 600;
      }

      .header-points {
        margin-top: -0.5rem;
        width: 100%;
        height: 4.5rem;
        font-size: 3.125rem;
        color: #fff;
        font-weight: 700;
      }
      
    }

  }

  .content-title-box {
    margin: 1rem 0;
    display: flex;
    align-items: center;

    .border-box {
      height: 1rem;
      border-left: .3125rem solid #3378EB;
      margin-right: 0.5rem;
      border-radius: 0.5rem;
    }

    .title-box {
      font-size: 1.25rem;
      font-weight: 600;
    }
  }

  .content-scroll-box {
    width: 100%;
    height: calc(100vh - 17.5rem);
    overflow: hidden;

    .for-content-box {
      width: 100%;
      // height: 100rem;

    }

    .content-box-item {
      width: 100%;
      height: 9.375rem;
      background-color: #fff;
      border-radius: .3125rem;
      overflow: hidden;
      margin-bottom: 1rem;

      .win {
        background: linear-gradient(to right, #5B8EFF, #C8ECFF);
      }

      .fail {
        background: linear-gradient(to right, #FF5B5B, #FFE2C8);
      }

      .content-box-item-top {
        width: 100%;
        height: 2.6875rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.5rem;

        .content-box-item-top-left {
          height: 100%;
          display: flex;
          align-items: center;
          color: #fff;

          .type-name {
            font-size: 1.125rem;
            font-weight: 600;
          }

          .time {
            margin-left: 0.5rem;
            font-size: 1rem;
            line-height: 100%;
            color: #fff;
          }
        }

        .content-box-item-top-right {
          font-size: 1.125rem;
          font-weight: 600;
        }

        .failType {
          color: #EB3333;
        }

        .winType {
          color: #3378EB;
        }
      }

      .content-box-item-bottom {
        .item-event-name-box {
          display: flex;
          padding: 0.5rem;

          .item-event-name-box-left {
            display: flex;
            align-items: center;

            .item-event-name-box-left-img {
              width: .5rem;
              height: .5rem;
              border: 0.2rem solid #3378EB;
              border-radius: 50%;
              margin-right: 0.3rem;
            }

            .item-event-name-box-left-name {
              margin-right:0.5rem;
              font-size: 1rem;
              font-weight: 600;
              overflow:hidden;
            }
          }

          .item-event-name-box-right {
            font-size: 1rem;
            font-weight: 600;
          }
        }
      }

      .vs-box {
        width: 18rem;
        height: 2.125rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        .vs-item-rule {
          width: 20.1563rem;
          height: 2.125rem;
          margin-top: 2rem;
          font-size: 1rem;
          font-weight: 700;
          color: #333333;
          text-align: left;
        }

        .vs-item-box {
          display: flex;
          align-items: flex-end;
          font-size: 1rem;

          .vs-item-left-number {
            font-size: 1.25rem;
            margin: 0 1.5rem;
          }

          .vs-item-right-number {
            font-size: 1.25rem;
            margin: 0 1.5rem;
          }

          .win-number {
            color: #3378EB;
          }

          .fail-number {
            color: #EB3333;
          }

          .vs-item-name-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .win-img {
              width: .9375rem;
              height: .6875rem;
            }

            .vs-item-name {
              width: 6.25rem;
              text-align: center;
              font-size: 1rem;
              color: #333333;
              // font-weight: 600;
            }
          }
        }

        .vs-text {
          width: 1.3125rem;
          height: 2rem;
          display: flex;
          align-items: flex-end;
          font-size: 1rem;
          font-weight: 700;
          color: #3378EB;
        }
      }
    }
  }
  .no-content-box-img{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4rem;
    font-size: 1.3rem;
    color: #333333;
  }
}
</style>